<script setup lang="ts">
const { showAfterScroll = 0, hideBeforeSroll = 0 } = defineProps<{
  hideBeforeSroll?: number
  showAfterScroll?: number
}>()
defineEmits<{
  'btn-clicked': []
}>()
defineSlots<{ default(): any }>()

const elRef = ref<HTMLDivElement | null>(null)
const parentRef = ref<HTMLElement | null>(null)

const isDisplayed = ref(
  !showAfterScroll ||
    (import.meta.client ? window.scrollY > showAfterScroll : false),
)
const onScroll = () => {
  const heightOffset = showAfterScroll + elRef.value!.offsetHeight
  const { height } = parentRef.value?.getBoundingClientRect() ?? {
    height: hideBeforeSroll,
  }
  isDisplayed.value =
    height > 0
      ? window.scrollY > showAfterScroll &&
        window.scrollY < height - heightOffset
      : false
}
onMounted(() => {
  if (showAfterScroll && elRef.value) {
    if (!hideBeforeSroll) parentRef.value = elRef.value.parentElement
    document.addEventListener('scroll', onScroll)
  }
})
onUnmounted(() => {
  if (showAfterScroll) {
    document.removeEventListener('scroll', onScroll)
  }
})
</script>

<template>
  <div ref="elRef" class="fixed bottom-6 right-6 z-sticky items-center gap-2">
    <!-- v-show avoids Uncaught TypeError: Cannot read properties of null (reading 'insertBefore') -->
    <!-- See https://github.com/vuejs/core/issues/5657 for details -->
    <BaseButton
      v-show="isDisplayed"
      v-bind="$attrs"
      @click="$emit('btn-clicked')"
    >
      <slot />
    </BaseButton>
  </div>
</template>
